import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpGroupsService } from '@services/cleanfill-core/http-groups/http-groups.service';
import { CleanFillGroupViewModel, CleanFillPolicyViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { UserRole } from '@services/auth/role.enum';

@Injectable({
  providedIn: 'root'
})
export class StoreGroupsService {
  private groupsSubj$ = new BehaviorSubject<CleanFillGroupViewModel[]>([]);
  groups$ = this.groupsSubj$.asObservable();

  subscription = new Subscription();
  constructor(private httpGroups: HttpGroupsService) {}

  loadGroups(): void {
    const sub = this.httpGroups.getAllGroups().subscribe(groups => this.groupsSubj$.next(groups));
    this.subscription.add(sub);
  }

  getGroupPoliciesSnapshot(groupCode: UserRole): CleanFillPolicyViewModel[] {
    const policiesGroup = this.groupsSubj$.value.find(g => groupCode === g.code);
    return policiesGroup?.cleanFillGroupPolicies?.map(gp => gp.cleanFillPolicy) || [];
  }

  getGroupUniqueIdByGroupNameSnapshot(groupCode: UserRole): string {
    const group = this.groupsSubj$.value.find(g => groupCode === g.code);
    return group.uniqueId;
  }
}
